import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgDigitalTransformationIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        stroke="currentColor"
        strokeWidth={0.5}
        d="M28 21.696a1.646 1.646 0 0 1-1.584-1.216h-3.84a.41.41 0 0 1-.304-.128l-1.344-1.344h-1.664a5.115 5.115 0 0 1-3.68 2.064v7.312a.43.43 0 0 1-.432.432h-1.76c-.56 0-1.024-.464-1.024-1.024v-1.184c-.032 0-.064-.016-.096-.016L11.68 27.6c-.272.496-.912.656-1.392.384l-3.056-1.776c-.496-.272-.656-.912-.384-1.392l.592-1.024c-.032-.016-.048-.048-.064-.064l-1.024.576a1.022 1.022 0 0 1-1.408-.368l-1.76-3.056a1.036 1.036 0 0 1 .368-1.408l1.024-.576c-.016-.032-.016-.064-.032-.112H3.376a1.01 1.01 0 0 1-1.024-1.024v-3.52a1.01 1.01 0 0 1 1.024-1.024h1.168c.016-.048.016-.08.032-.112l-1.024-.576a1.036 1.036 0 0 1-.368-1.408l1.76-3.056c.288-.48.928-.656 1.408-.368l1.008.576c.032-.016.048-.048.08-.064l-.592-1.024c-.272-.48-.112-1.12.384-1.392l3.04-1.776a1.041 1.041 0 0 1 1.408.384l.592 1.008c.032 0 .064-.016.096-.016V4.208c0-.56.464-1.024 1.024-1.024h1.76a.43.43 0 0 1 .432.432v7.312a5.115 5.115 0 0 1 3.68 2.064h1.664l1.344-1.344a.41.41 0 0 1 .304-.128h3.84c.496-1.84 3.232-1.488 3.232.432s-2.736 2.256-3.232.416h-3.664l-1.344 1.344a.437.437 0 0 1-.304.128h-1.328c.24.544.416 1.12.464 1.728h3.664c.496-1.824 3.232-1.488 3.232.432s-2.736 2.256-3.232.432H20.24c-.048.608-.224 1.184-.464 1.728h1.328c.112 0 .224.032.304.112l1.344 1.344h3.664c.496-1.824 3.232-1.488 3.232.432 0 .912-.736 1.648-1.648 1.648Zm-13.264 2.656C10.32 24.128 6.8 20.464 6.8 16s3.52-8.128 7.936-8.352v-3.6h-1.344c-.096 0-.176.08-.176.16 0 2.128.224 1.728-1.024 2.112a.413.413 0 0 1-.496-.192l-.752-1.312c-.048-.08-.144-.112-.24-.048l-3.056 1.76c-.08.048-.112.144-.064.24 1.056 1.824 1.072 1.376.16 2.336a.415.415 0 0 1-.512.08L5.92 8.432a.18.18 0 0 0-.24.064l-1.76 3.056a.18.18 0 0 0 .064.24c1.856 1.056 1.6.688 1.312 1.936a.442.442 0 0 1-.416.336H3.376a.178.178 0 0 0-.176.176v3.52c0 .096.08.176.176.176 2.112 0 1.728-.208 2.096 1.024a.413.413 0 0 1-.192.496l-1.296.752a.18.18 0 0 0-.064.24l1.76 3.056a.18.18 0 0 0 .24.064c1.824-1.04 1.376-1.056 2.352-.16a.414.414 0 0 1 .064.528l-.752 1.312c-.048.08-.016.192.064.224l3.056 1.776a.18.18 0 0 0 .24-.064c1.088-1.904.736-1.6 1.952-1.312.192.032.32.208.32.4v1.52c0 .08.08.16.176.16h1.344zm0-.848v-2.432A5.09 5.09 0 0 1 10.064 16a5.09 5.09 0 0 1 4.672-5.072V8.496C10.784 8.72 7.648 12 7.648 16s3.136 7.28 7.088 7.504Zm.416-11.744c-2.32 0-4.24 1.904-4.24 4.24s1.92 4.24 4.24 4.24a4.237 4.237 0 0 0 4.24-4.24 4.237 4.237 0 0 0-4.24-4.24Zm0 6.48A2.233 2.233 0 0 1 12.928 16c0-1.232.992-2.24 2.224-2.24a2.236 2.236 0 0 1 2.24 2.24c0 1.232-.992 2.24-2.24 2.24Zm0-3.632A1.39 1.39 0 0 0 13.776 16a1.39 1.39 0 0 0 1.376 1.392 1.393 1.393 0 0 0 0-2.784Zm12.064 5.408c0 .48.336.832.784.832 1.04 0 1.04-1.584 0-1.584a.79.79 0 0 0-.784.752Zm-2.512-4.048c0 .48.336.832.784.832 1.04 0 1.04-1.6 0-1.6a.792.792 0 0 0-.784.768ZM28 11.152c-1.04 0-1.04 1.6 0 1.6s1.04-1.6 0-1.6Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDigitalTransformationIcon;
